module.exports = __webpack_public_path__ + "static/media/contact-banner-mtn.9ec91ad3.png";